import { render, staticRenderFns } from "./KeyValuesAdd.vue?vue&type=template&id=148d472c&scoped=true&"
import script from "./KeyValuesAdd.vue?vue&type=script&lang=js&"
export * from "./KeyValuesAdd.vue?vue&type=script&lang=js&"
import style0 from "./KeyValuesAdd.vue?vue&type=style&index=0&id=148d472c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d472c",
  null
  
)

export default component.exports